export default __webpack_public_path__ + "static/media/Light.78436518.eot";